import { LIST_ROLES_AUTHORIZE_BACK_OFFICE_ADMIN } from '@/types/enum/constants'

const getIsUserBackOffice = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value =>
    LIST_ROLES_AUTHORIZE_BACK_OFFICE_ADMIN.find(role => role === value)
  ) || false

export const haveRole = (loggedUserRoles: string[], roles: string[]): boolean =>
  (loggedUserRoles && !!loggedUserRoles.find(value => roles.includes(value))) || false

export default getIsUserBackOffice
